import { ENTITY_TYPE } from '@/constants/entities'

/**
 * This takes the notification object as input, and return the entity type to which it belongs to.
 * @param notification
 * @returns {string}
 */
export default notification => {
  if (notification.data.initiativeId) {
    return ENTITY_TYPE.INITIATIVE
  } else if (notification.data.keyResultId) {
    return ENTITY_TYPE.KEY_RESULT
  } else if (notification.data.goalId) {
    return ENTITY_TYPE.GOAL
  }
}
